import {Checkbox} from 'antd';
import {isEqual} from 'lodash';
import {memo, useMemo, useState} from 'react';

import {Form} from '../../../../../../../typings/antd';
import {useAttributesState} from '../attributes-context';
import {AttributeType, EnumAttributeType} from '../attributes-type';

import {limit} from './enum-attribute-const';
import {EnumAttributeToggleButton} from './enum-attribute-toggle-button';
import * as styles from './enum-attribute.scss';

type PropsType = {
    onChange: (value: AttributeType) => void;
    value: EnumAttributeType;
};

function EnumMultipleAttributeComponent(props: PropsType): JSX.Element {
    const {value} = props;
    const {displayName: label, values, internalName} = value;
    const {attributesState, updateAttribute} = useAttributesState();

    const currentAttribute = (attributesState.get(internalName) as EnumAttributeType) || value;
    const currentValues = currentAttribute.values;

    const hasHiddenSelectedValues = currentValues
        .filter((_value, index) => index + 1 > limit)
        .some(({selected}) => Boolean(selected));

    const [showAll, setShowAll] = useState(currentValues.length <= limit || hasHiddenSelectedValues);

    const checked = useMemo(
        () => currentValues.filter((item) => item.selected).map(({templateId}) => templateId),
        [currentValues]
    );

    function handleChange(newChecked: Array<number | string>) {
        updateAttribute(internalName, {
            ...value,
            values: values.map((item) => ({
                ...item,
                selected: newChecked.map(String).includes(String(item.templateId)),
            })),
        });
    }

    return (
        <Form.Item className={styles.form_item} label={label}>
            <Checkbox.Group onChange={handleChange} value={checked}>
                <div className={styles.enum_attribute}>
                    {(showAll ? currentValues : currentValues.slice(0, limit)).map((option) => (
                        <Checkbox key={option.templateId} value={option.templateId}>
                            {option.displayValue}
                        </Checkbox>
                    ))}
                </div>

                {currentValues.length > limit && (
                    <EnumAttributeToggleButton setShowAll={setShowAll} showAll={showAll} />
                )}
            </Checkbox.Group>
        </Form.Item>
    );
}

// there can be dozens of checkbox groups and hundreds of checkboxes in 1 category
export const EnumMultipleAttribute = memo(EnumMultipleAttributeComponent, (previous, next) =>
    isEqual(previous.value, next.value)
);
